import { HTTP_CP_ListMortgageCases_Response } from '@api-new/caseservice';
import { createAction, props } from '@ngrx/store';
import { ErrorModel } from '@shared-lib/models/error.model';

export const getMortgageCases = createAction('[MORTGAGE-CASES] Get Mortgage Cases');
export const closeMortgageCase = createAction('[MORTGAGE-CASES] Close Mortgage Case');

export const closeMortgageCasesSuccess = createAction(
  '[MORTGAGE-CASES] Close Mortgage Case Success',
  props<{
    mortgageCaseId: string;
  }>(),
);

export const getMortgageCasesSuccess = createAction(
  '[MORTGAGE-CASES] Get Mortgage Cases Success',
  props<HTTP_CP_ListMortgageCases_Response>(),
);
export const getMortgageCasesFailure = createAction('[MORTGAGE-CASES] Get Mortgage Cases Failure', props<{ error: ErrorModel }>());
